import React, { useState } from 'react';
import './Ghiblifi.css';

function Ghiblifi() {
  // const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const validateFile = (file) => {
    // Check file type
    if (!file.type.startsWith('image/')) {
      throw new Error('Please upload an image file');
    }

    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      throw new Error('File size must be less than 5MB');
    }

    return true;
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setError(null);
      validateFile(file);
      // setImage(URL.createObjectURL(file));
      setLoading(true);

      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch('/api/ghiblifi', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setResult(data.result);
    } catch (error) {
      console.error('Error processing image:', error);
      setError(error.message || 'An error occurred while processing the image');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ghiblifi-container">
      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        className="ghiblifi-input"
      />
      
      {loading && <div className="ghiblifi-loading">Processing...</div>}
      
      {error && <div className="ghiblifi-error">{error}</div>}
      
      {result && (
        <div className="ghiblifi-result">
          <img src={result} alt="Anime style result" />
        </div>
      )}
    </div>
  );
}

export default Ghiblifi;